import videojs from 'video.js';
import './Player.scss';
import 'videojs-seek-buttons/dist/videojs-seek-buttons.css';
import 'videojs-seek-buttons';
import 'videojs-hotkeys';
import { notifyWithFullscreenClose } from '../utiliti';

// import '../contrib-quality-levelts';

const { IS_IPHONE, IOS_VERSION } = videojs.browser;
let previousTime = 0,
  currentTime = 0,
  seekStartTimeStamp = null,
  seekStart = null;
videojs.hook('setup', vjsPlayer => {
  vjsPlayer.playsinline(vjsPlayer.options_.playsinline !== false);
  vjsPlayer.addClass('video-js');
  localStorage.setItem('watchStats', JSON.stringify([]));
  const sendStats = () => {
    const stats = localStorage.getItem('watchStats')
      ? JSON.parse(localStorage.getItem('watchStats'))
      : [];

    if (
      !vjsPlayer.paused() &&
      (isNaN(vjsPlayer.duration()) ||
        vjsPlayer.duration() > vjsPlayer.currentTime())
    ) {
      if (stats.length) {
        stats[stats.length - 1]['endTime'] = Math.max(
          vjsPlayer.currentTime(),
          stats[stats.length - 1]['endTime']
        );
        stats[stats.length - 1]['endTimeTimestamp'] = new Date().getTime();
      }
      localStorage.setItem('watchStats', JSON.stringify(stats));

      parent.postMessage(
        {
          type: 'WATCH_STATS',
          duration: vjsPlayer.duration(),
          progress: vjsPlayer.currentTime(),
          stats
        },
        '*'
      );
    }
    let timeSpent = 0;
    stats.forEach(s => {
      timeSpent += (s['endTimeTimestamp'] - s['startTimeTimestamp']) / 1000;
    });
    console.log(`---------------watch time------------- ${timeSpent}sec`);
    setTimeout(() => {
      sendStats();
    }, 5000);
  };
  sendStats();

  vjsPlayer.on('play', function (e) {
    const stats = localStorage.getItem('watchStats')
      ? JSON.parse(localStorage.getItem('watchStats'))
      : [];
    stats.push({
      endTime: vjsPlayer.currentTime(),
      endTimeTimestamp: new Date().getTime(),
      startTime: vjsPlayer.currentTime(),
      startTimeTimestamp: new Date().getTime()
    });
    localStorage.setItem('watchStats', JSON.stringify(stats));
  });
  const eventReceivedFromParent = e => {
    if (vjsPlayer && e && e.data) {
      switch (e.data.type) {
        case 'TIMELINE_CLICKED':
          vjsPlayer.currentTime(parseInt(e.data.timestamp));
          break;
        case 'ASK_SAARTHI_CLICKED':
          if (!vjsPlayer.paused()) {
            vjsPlayer.pause();
          }
          parent.postMessage(
            { type: 'ASK_SAARTHI', timestamp: vjsPlayer.getCurrentTime() },
            '*'
          );
          break;
        case 'PLAYER_ONLINE':
          console.log('player online');
          // vjsPlayer.play();
          break;
        case 'JOIN_MEET_CLICKED':
          console.log('join meet to be checked');
          break;
        case 'PLAY_CLICKED':
          vjsPlayer.play();
          break;
        case 'PLAYER_OFFLINE':
          console.log('player offline');
          console.log(vjsPlayer);
          // vjsPlayer.stop();
          break;
        case 'PAUSE_CLICKED':
          vjsPlayer.pause();
          break;
        case 'MUTE_CLICKED':
          vjsPlayer.muted(true);
          break;
        case 'UN_MUTE_CLICKED':
          vjsPlayer.muted(false);
          break;
        case 'FORWARD_CLICKED':
          vjsPlayer.currentTime(vjsPlayer.currentTime() + 10);
          break;
        case 'BACKWARD_CLICKED':
          vjsPlayer.currentTime(Math.max(vjsPlayer.currentTime() - 10, 0));
          break;

        case 'JOIN_MEET_RECEIVED':
          let el = document.getElementById('vjs-custom-meet-button');
          el.classList.remove('vjs-custom-meet-button-hidden');
          el.classList.add('vjs-custom-meet-button-show');
          break;
        case 'JOIN_MEET_EXPIRED':
          const _el = document.getElementById('vjs-custom-meet-button');
          _el.classList.remove('vjs-custom-meet-button-show');
          _el.classList.add('vjs-custom-meet-button-hidden');
        case '3D_CLICKED':
          parent.postMessage(
            { type: '3D_CLICKED', timestamp: vjsPlayer.getCurrentTime() },
            '*'
          );
          break;
        case 'POLL_STARTED':
          let _pollImageIcon = document.getElementById('poll-image');
          _pollImageIcon.src = 'poll-active.svg';
          let ele = document.getElementById('vjs-custom-poll-button');
          //   ele.classList.add('vjs-custom-poll-received');
          break;
        case 'POLL_ENDED':
          let _pollImage = document.getElementById('poll-image');
          _pollImage.src = 'polls.svg';
          //   ele.classList.remove('vjs-custom-poll-received');
          break;
        case 'SIDE_BAR_CHANGED':
          const sideBarMenu = e?.data?.sideBar;
          Object.keys(sideBarMenu).forEach(el => {
            document.getElementById(el)?.classList?.add('vjs-inactive');
            if (sideBarMenu[el]) {
              document.getElementById(el)?.classList?.remove('vjs-inactive');
            }
          });
      }
    }
  };

  window.addEventListener('dblclick', function () {
    console.log('DOUBLE click');
    const btn = document.getElementsByClassName('vjs-fullscreen-control')[0];
    if (btn) {
      const title = btn.getAttribute('title');
      if (title === 'Full Screen')
        btn.innerHTML =
          "<img src='minimize.svg'><span class='vjs-control-text' aria-live='polite'>Exit Full screen</span>";
      else
        btn.innerHTML =
          "<img src='maximize.svg'><span class='vjs-control-text' aria-live='polite'>Full Screen</span>";
    }
    if (!localStorage.getItem('window_full_screen')) {
      if (!vjsPlayer.isFullWindow) {
        vjsPlayer.enterFullScreen();
      } else {
        vjsPlayer.exitFullscreen();
      }
    } else {
      if (localStorage.getItem('full_screen_mode')) {
        notifyWithFullscreenClose(vjsPlayer, {
          type: 'EXIT_FULL_SCREEN',
          currentTime: vjsPlayer.currentTime()
        });
        btn.setAttribute('title', 'Full Screen');
        localStorage.removeItem('full_screen_mode');
      } else {
        notifyWithFullscreenClose(vjsPlayer, {
          type: 'GO_FULL_SCREEN',
          currentTime: vjsPlayer.currentTime()
        });
        btn.setAttribute('title', 'Exit Full Screen');
        localStorage.setItem('full_screen_mode', true);
      }
    }
  });
  document.getElementById('forward-seek-button').onclick = function () {
    var div = document.getElementById('actions-animation');
    div.className =
      'grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute';
    div.innerHTML = `<div class="col-span-2"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center ">
        <img src="forward.gif" id="forward-img" class="seek-img" />
      </div>
    `;
    // document.appendChild(div);
    setTimeout(() => {
      div.innerHTML = '';
      div.classList.remove('z-[1000]');
    }, 500);
    vjsPlayer.currentTime(vjsPlayer.currentTime() + 10);
  };
  document.getElementById('replay-seek-button').onclick = function () {
    var div = document.getElementById('actions-animation');
    div.className =
      'grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute';
    div.innerHTML = `
     <div class="flex flex-row items-center justify-center col-span-1 text-center ">
        <img src="backward.gif" id="backward-img" class="seek-img" />
      </div>
    `;
    setTimeout(() => {
      div.innerHTML = '';
      div.classList.remove('z-[1000]');
    }, 500);
    vjsPlayer.currentTime(vjsPlayer.currentTime() - 10);
  };
  setTimeout(() => {
    window.addEventListener('message', eventReceivedFromParent, false);
    if (!vjsPlayer.options_.defaultPaused) {
      vjsPlayer.play();
    }
    vjsPlayer.muted(vjsPlayer.options_.defaultMuted || false);
    vjsPlayer.on('pause', function () {
      parent.postMessage(
        {
          type: 'VIDEO_PAUSED',
          progress: vjsPlayer.currentTime(),
          duration: vjsPlayer.duration(),
          videoDetails: vjsPlayer.options_.videoDetails
        },
        '*'
      );
    });
    vjsPlayer.on('timeupdate', () => {
      previousTime = currentTime;
      currentTime = vjsPlayer.currentTime();
    });

    vjsPlayer.on('seeking', () => {
      if (seekStart === null) {
        seekStartTimeStamp = new Date().getTime();
        seekStart = previousTime;
      }
    });

    vjsPlayer.on('seeked', () => {
      const data = {
        seekStartTimeStamp: seekStartTimeStamp,
        remainingTime: vjsPlayer.remainingTime(),
        currentTime,
        startTime: seekStart,
        progress: vjsPlayer.currentTime(),
        duration: vjsPlayer.duration(),
        videoDetails: vjsPlayer.options_.videoDetails
      };
      seekStart = null;
      seekStartTimeStamp = null;
      parent.postMessage({ type: 'SEEKED', data }, '*');
    });
    window.pla = vjsPlayer;
    vjsPlayer.on('play', function () {
      parent.postMessage(
        {
          type: 'VIDEO_PLAYED',
          progress: vjsPlayer.currentTime(),
          duration: vjsPlayer.duration(),
          videoDetails: vjsPlayer.options_.videoDetails
        },
        '*'
      );
    });
    vjsPlayer.on('playing', function () {
      parent.postMessage(
        {
          type: 'VIDEO_PLAYING',
          progress: vjsPlayer.currentTime(),
          duration: vjsPlayer.duration(),
          videoDetails: vjsPlayer.options_.videoDetails
        },
        '*'
      );
    });

    vjsPlayer.on('ended', function () {
      parent.postMessage(
        {
          type: 'VIDEO_ENDED',
          duration: vjsPlayer.duration(),
          videoDetails: vjsPlayer.options_.videoDetails
        },
        '*'
      );
    });
  }, 10);
  vjsPlayer.seekButtons({
    forward: 10,
    back: 10
  });
  vjsPlayer.hotkeys({
    volumeStep: 0.1,
    seekStep: 10,
    enableModifiersForNumbers: false,
    alwaysCaptureHotkeys: true
  });

  if (
    document.getElementsByClassName('vjs-play-control') &&
    document.getElementsByClassName('vjs-play-control').length
  ) {
    document.getElementsByClassName('vjs-play-control')[0].focus();
  }

  if (document.getElementsByClassName('custom-setting-button-icon')[0]) {
    const icon = videojs.dom.createEl('img', {
      src: 'settings.svg',
      className: 'vjs-custom-action-icons vjs-custom-action-icons-animate'
    });
    document
      .getElementsByClassName('custom-setting-button-icon')[0]
      .childNodes[0].appendChild(icon);
  }

  // if (typeof parent !== "undefined") {
  //     parent.player = vjsPlayer;
  // }
  // if (typeof window !== "undefined") {
  //     window.player = vjsPlayer;
  // }
  const btn = document.getElementsByClassName('vjs-fullscreen-control')[0];
  if (btn) {
    if (localStorage.getItem('full_screen_mode')) {
      btn.setAttribute('title', 'Exit Full Screen');
    } else {
      btn.setAttribute('title', 'Full Screen');
    }
    const title = btn.getAttribute('title');
    if (title === 'Full Screen') {
      btn.innerHTML =
        "<img src='maximize.svg' class='vjs-custom-action-icons'><span class='vjs-control-text' aria-live='polite'>Full Screen</span>";
    } else
      btn.innerHTML =
        "<img src='minimize.svg' class='vjs-custom-action-icons'><span class='vjs-control-text' aria-live='polite'>Exit Full Screen</span>";
    btn.addEventListener('click', function () {
      parent.postMessage({ type: 'FULL_SCREEN_CHANGED' }, '*');
    });
  }
  const playBtn = document.getElementsByClassName('vjs-play-control')[0];
  if (playBtn) {
    playBtn.classList.add('vjs-custom-action-icons');
  }
  const volumebtn = document.getElementsByClassName('vjs-mute-control')[0];
  if (volumebtn) {
    volumebtn.classList.add('vjs-custom-action-icons');
  }
  if (IS_IPHONE) {
    vjsPlayer.addClass('vjs-is-iphone');
    if (IOS_VERSION < 11) {
      vjsPlayer.addClass('vjs-iphone-below-11');
    }
  }
});
